import { HeroSection } from "@/components/sections/HeroSection";
import { MenuGridSection } from "@/components/sections/MenuGridSection";
import { RedefiningSection } from "@/components/sections/RedefiningSection";
import { ArtSection } from "@/components/sections/ArtSection";
import { Footer } from "@/components/sections/Footer";
import { Seo } from "@/components/Seo";
import { useBurgers } from "@/hooks/use-burgers";

const Index = () => {
  const { burgers } = useBurgers();

  const menuJsonLd = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    name: "Nafloniya Burger",
    url: "https://nafloniyaburger.lovable.app/",
    servesCuisine: "Burgers",
    priceRange: "$$",
    hasMenu: {
      "@type": "Menu",
      name: "Our Premium Collection",
      hasMenuSection: {
        "@type": "MenuSection",
        name: "Burgers",
        hasMenuItem: burgers.map((burger) => ({
          "@type": "MenuItem",
          name: burger.name,
          description: burger.description,
          offers: {
            "@type": "Offer",
            price: burger.price.toFixed(2),
            priceCurrency: "USD",
          },
        })),
      },
    },
  };

  return (
    <div className="overflow-x-hidden">
      <Seo
        title="Nafloniya Burger — Premium Gourmet Burgers"
        description="Nafloniya Burger serves premium gourmet burgers made fresh to order. Browse the menu, pick your add-ons and order in minutes."
        path="/"
        jsonLd={menuJsonLd}
      />
      <main>
        <HeroSection />
        <MenuGridSection />
        <RedefiningSection />
        <ArtSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
